module.exports = __webpack_public_path__ + "static/media/meltemGoz.76d62894.png";